(function ($) {
	$.fn.lightbox = function (options) {
		if (!this.length) {
			return this;
		}

		const defaults = {
			open: function () {},
			close: function () {},
		};

		const plugin = this;
		const el = $(this);

		plugin.settings = {};
		plugin.settings = $.extend({}, defaults, options);

		const s = plugin.settings;

		// construct lightbox on click and add it to DOM
		el.on("click", function (e) {
			e.preventDefault();
            
			const id = $(this).attr("href");
			const content = $(id).html();
            console.log("HERE");
			let modClasses = "";

			if (el.attr("data-mods")) {
				const mods = el.attr("data-mods").split(",");

				for (let i = 0; i < mods.length; i++) {
					modClasses += ` lightbox--${mods[i]}`;
				}
			}

			let markup = `<section class="lightbox${modClasses}" data-origin-id="${id}"><div class="lightbox__overlay overlay"></div><div class="lightbox__box"><div class="lightbox__viewport"><div class="lightbox__content">`;

			markup += `<div class="lightbox__data"><a href="#" class="lightbox__close" title="Close Lightbox">x</a>${content}</div></div></div></div></section>`;
               console.log(markup)
			// disable scroll
			$("body").css("overflow", "hidden");

			//$('body, html').scrollTop(0);
			//$('main, footer').hide();
			$("body").append(markup);

			s.open.call(this);
		});

		// remove lightbox from DOM when closed
		$("body").on("click", ".lightbox__close", function (e) {
			e.preventDefault();

			// enable scroll
			$("body").css("overflow", "auto");

			// remove lightbox
			$(this).closest(".lightbox").remove();

			s.close.call(this);
		});
	};
})(jQuery);

$(".lb").lightbox();
